import env from '@framework/env/env';

const iceServersConfig: string = env('METERED__ICE_SERVERS');

export default iceServersConfig;
